import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Web Development",
    date: "08 Apr, 2026",
    admin: "Admin",
    heading: "Complete Guide to Installing an HTML Template (Step-by-Step)",
    content: "Installing an HTML template is simple if you follow the right steps.",
    important: {
      content: "Installing an HTML template involves extracting files, understanding the folder structure, uploading to a server or localhost, and customizing content.",
      intro: "Web Developer"
    },
    points: [
      {
        title: "📦 Step 1: Download & Extract",
        description: "Download your template ZIP file, extract it using WinRAR or 7-Zip, and open the /HTML folder which contains all your website files."
      },
      {
        title: "📁 Step 2: Understand Structure",
        description: "Your template contains index.html for homepage, /assets folder for CSS, JS, images, and PHP files, and /pages folder for inner pages."
      },
      {
        title: "🌐 Step 3: Upload to Server",
        description: "Login to your hosting cPanel, open public_html directory, upload all template files, and extract if needed. Your site will then run on your domain."
      },
      {
        title: "💻 Step 4: Run on Localhost",
        description: "Install XAMPP, place your files in C:\\xampp\\htdocs\\, and open http://localhost/HTML/index.html in your browser."
      },
      {
        title: "✏️ Step 5: Customize Content",
        description: "Edit HTML files to change text content, replace images in /assets/images folder, and modify styles in CSS files to match your brand."
      },
      {
        title: "⚙️ Step 6: Test Everything",
        description: "Check all pages for errors, test contact forms to ensure they work, and verify mobile responsiveness across different devices."
      },
      {
        title: "🚀 Step 7: Done!",
        description: "Your HTML template is now installed and ready to use. Start adding your products, blog posts, or services to launch your website."
      }
    ],
    tags: ["HTML", "Template Installation", "Web Development", "Beginner Guide"]
  },
  {
    id: 2,
    image: images.blog2,
    category: "PHP Development",
    date: "10 Apr, 2026",
    admin: "Admin",
    heading: "How to Set Up Contact Forms Using PHP and PHPMailer (SMTP Guide)",
    content: "This guide will help you configure SMTP and get your form working perfectly.",
    important: {
      content: "Setting up a contact form requires PHPMailer library, Gmail SMTP configuration, and a 16-character App Password. Never use your regular Gmail password.",
      intro: "PHP Developer"
    },
    points: [
      {
        title: "📦 Step 1: Understand the PHP File Structure",
        description: "Your template contains /assets/php folder with submit.php for contact form and newsletter.php for newsletter subscription. Also includes PHPMailer library files: Exception.php, PHPMailer.php, and SMTP.php."
      },
      {
        title: "🔐 Step 2: Enable 2-Step Verification on Google",
        description: "Login to your Google Account, go to Security tab, click on 2-Step Verification, click Get Started, enter your password, verify your phone number, and enter the verification code to enable it."
      },
      {
        title: "🔑 Step 3: Generate Gmail App Password",
        description: "After enabling 2-Step Verification, go to App passwords under Signing in to Google. Select 'Mail' from Select app and 'Other' from Select device, give it a name like 'Contact Form', and click Generate. Copy the 16-character code."
      },
      {
        title: "⚙️ Step 4: Configure submit.php File",
        description: "Open /assets/php/submit.php. Update Username with your Gmail ID, Password with your 16-character App Password, addAddress with the email where you want to receive form submissions, and setFrom with your sender email and name."
      },
      {
        title: "📧 Step 5: Update Email Subject and Settings",
        description: "Change the Subject line to something like '(YourSite) New Contact Form Message'. You can also customize the email body template and add CC/BCC recipients if needed."
      },
      {
        title: "📰 Step 6: Configure newsletter.php Similarly",
        description: "Open /assets/php/newsletter.php and apply the same SMTP settings - Username, Password, addAddress, and setFrom. This ensures your newsletter subscription form also works properly."
      },
      {
        title: "🧪 Step 7: Test Your Contact Form",
        description: "Run your site on localhost using XAMPP or upload to live server. Fill out the contact form and submit. Check your recipient email inbox. The email should arrive within seconds using SMTP."
      }
    ],
    tags: ["PHP", "PHPMailer", "SMTP", "Contact Form", "Gmail API", "Email Setup"]
  },

];

export default blogs;